import { defineMessages } from 'react-intl';

export default defineMessages({
    paVehicleRightRailTitle: {
        id: 'quoteandbind.pa.views.pa-vehicles-details.Your Vehicles',
        defaultMessage: 'Your Vehicles',
    },
    paVehicleMainSectionHeader: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.MainSectionHeader',
        defaultMessage: 'VEHICLE {index} OF {length}',
    },

    wellReviewYourAdditionalVehiclesNext: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.We\'ll review your additional vehicles next',
        defaultMessage: 'We\'ll review your {additionalvehicles} next'
    },
    wellWorkYourAdditionalVehiclesNext: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.We\'ll work on your additional vehicles next',
        defaultMessage: 'We\'ll work on your {additionalvehicles} next'
    },
    wellReviewYourAdditionalInfoNext: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.We\'ll review your additional information next',
        defaultMessage: 'We\'ll review your {additionalinformation} next'
    },
    wellGatherYourAdditionalInfoNext: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.Next, we\'ll gather some additional information',
        defaultMessage: 'Next, we\'ll gather some {additionalinformation}'
    },
    additionalVehicles: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.additional vehicles',
        defaultMessage: 'additional vehicles'
    },
    additionalInformation: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.additional information',
        defaultMessage: 'additional information'
    },
    nonOwnedErrorMsg: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.nonOwnedErrorMsg',
        defaultMessage: 'We\'re sorry, we are unable to complete your quote on line at this time due to the non-owned vehicle. You can contact customer service by chat or call us at 1-844-438-8430.'
    },
    nonOwnedErrorMsgQnB: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.nonOwnedErrorMsgQnB',
        defaultMessage: 'We\'re sorry, we are unable to complete your quote on line at this time due to the non-owned vehicle. You can contact customer service by call us at 1-844-438-8430.'
    },
    nonOwnedContacUsMsg: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.nonOwnedContacUsMsg',
        defaultMessage: 'When contacting us, include your quote number {quoteID}.'
    },
    commuteAlert: {
        id: 'ml.quoteandbind.pa.views.pa-vehicle-details.One or more drivers are listed as employed and no vehicles are listed as commute to work or business use. Please review and update if needed.',
        defaultMessage: 'One or more drivers are listed as employed and no vehicles are listed as commute to work or business use. Please review and update if needed.'
    },
     mlUwIssueNormalFlowContentQB: {
        id: 'ml.quoteandbind.views.contact-us.Please give us a call at ',
        defaultMessage: 'Please give us a call at {phoneNum} and mention your quote number {quoteID}. One of our licensed specialists will be happy to help you complete your quote. '
    },
    mlUwIssueNormalFlowQB: {
        id: 'ml.quoteandbind.views.contact-us.We need a little more information',
        defaultMessage: 'We need a little more information to finish your quote. '
    },
    nonOwned: {
        id: 'ml.quoteandbind.views.contact-us.nonOwned',
        defaultMessage: 'Non Owned'
    },
    maxTwoYearsAllowedForPurchaseYear: {
        id: 'ml.quoteandbind.views.contact-us.maxTwoYearsAllowedForPurchaseYear',
        defaultMessage: 'Change the Purchase Date. Year purchased cannot be more than 2 years prior to model year for Vehicle {vehicleName}'
    },
    allVehiclesStorageError: {
        id: 'ml.quoteandbind.views.allVehiclesStorageError',
        defaultMessage: 'A policy cannot have all vehicles primarily used for storage. Please update the usage for one of the vehicles.'
    },
    valueAmountIsLessThanThreeThousand: {
        id: 'ml.quoteandbind.views.contact-us.valueAmountIsLessThanThreeThousand',
        defaultMessage: 'The value you entered is lower than the minimum required amount. Please enter $3,000 or greater to proceed.'
    },
    costNewRequiredQB: {
        id: "ml.quoteandbind.views.contact-us.costNewRequiredQB",
        defaultMessage: "Please enter a valid costNew amount"
    },

});
